module.exports = __webpack_public_path__ + "static/marketplace-studio-97556948ddffb8d9738543eda5c8d2d6.svg";